import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { useForm, Controller, ErrorMessage } from "react-hook-form";
import { Row, Col, Container } from "deltoid/core/Blocks/BootstrapContainers";
import { H } from "deltoid/core/Blocks/Typography";
import Form from "deltoid/core/Form";
import SingleFileUploader from "./SingleFileUploader";
import { DOCUMENT_CATEGORY_GENERIC_DATA } from "@constants/manualUploadConstants";
import { toastActions, uiActions, dialogActions, dialogSelectors, manualUploadActions } from "@store/ducks";
import capitalize from "lodash/capitalize";
import DeleteIcon from "deltoid/assets/images/deleteIcon.inline.svg";

const ConfirmationDialog = ({ onNegativeClick, onPositiveClick, className }) => {
  return (
    <>
      <div className={`mod-confirmation-wrap ${className}`}>
        <div className="mod-top-title-wrap">
          <H level={6} variant="bold" className="modal-heading">
            {/* {modalTitle} */}
            Are you sure you want to cancel?
          </H>
          <p className="modal-subtext">
            {/* {modalSubTitle} */}
            If you cancel, this document will not be saved.
          </p>
        </div>
      </div>
      <div className={`mod-btn-bottom-row ${className}`}>
        <Form.Button variant="default" className="btn-cancel" onClick={onNegativeClick}>
          No
        </Form.Button>
        <Form.Button variant="default" className="btn-upload" onClick={onPositiveClick} disabled={false}>
          Yes, Cancel
        </Form.Button>
      </div>
    </>
  );
};

export default ConfirmationDialog;
